import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';
import Nomenclatures from "@/module/store/nomenclatures"
import {iNomCategOfEvents} from '@/types/iNomCategOfEvents';
import {iNomTypesOfEvents} from '@/types/iNomTypesOfEvents';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import {I_List} from "@/types/iList";

interface I_AjaxResponse_SaveList{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
        listid:number
    }
}

@Component({components:{}})
export default class NewGiftsList extends Vue {
    myBoolTrue:boolean=true;
    myBoolFalse:boolean=false;
    loadingApp:boolean=false;
    xsm:string='xsm';
    ajaxIsRunning:boolean=false;
    new_list:I_List={
        listid:0,
        userid:0,
        list_name:'',
        name_of_titular_event:'',
        type_of_event:0,
        contact_phone:'',
        event_time:'',
        event_time_data:'',
        event_time_ora:'',
        privacy_type:'',
        password_list:'',
        description:'',
        location_county:'',
        location_city:'',
        location_street:'',
        location_text:'',
        type_of_titular_event:'',
        status:'',
        url_for_img:'',
        has_attached_image:''
    }

    $refs:any;
    private userStore=getModule(User)
    private nomenclaturesStore=getModule(Nomenclatures);

    async saveList(plist:I_List){
        const vueInst=this;
        let res = await <Promise<I_AjaxResponse_SaveList>> axios.post(`${CONFIG_ENV.URL_GIFTS.new_list}`,plist);
        return res;
    }

    constructor(){
        super();
    }

    tryToSaveList(){
        const vueInst=this;
        vueInst.saveList(vueInst.new_list).then((response:I_AjaxResponse_SaveList)=>{
            if(response.data.status=='success'){
                vueInst.$router.push({ name: 'works_a_list', params: { listid: response.data.listid.toString() } })
            }else{
                vueInst.$q.notify({
                    color: 'red-5',
                    textColor: 'white',
                    position:'top-right',
                    icon: 'fas fa-exclamation-triangle',
                    message: response.data.message
                });
            }
        });
    }

    nomTypeOfEventForCateg(pcateg_id:number){
        return this.nomenclaturesStore.nom_types_of_events.filter((ptype_of_event:iNomTypesOfEvents)=>{
            return 1*ptype_of_event.categ_id==1*pcateg_id;
        });
    }

    goToMyHomePage(){
        this.$router.push({name: 'my_home_page'})
    }

    get nomTypeOfEvent(){
        return this.nomenclaturesStore.nom_types_of_events;
    }

    get nomCategOfEvent(){
        return this.nomenclaturesStore.nom_categ_of_events;
    }

    get nameOfTypeEvent():string{
        const vueInst=this;
        let type_event= this.nomenclaturesStore.nom_types_of_events.find((ptype_of_event:iNomTypesOfEvents)=>{
            return 1*ptype_of_event.type_id==1*vueInst.new_list.type_of_event;
        });
        if(type_event){ return type_event.den_ro;}
        else return '';
    }

    activated(){
        const vueInst=this;
        vueInst.new_list={
            listid:0,
            userid:0,
            list_name:'',
            name_of_titular_event:'',
            type_of_event:0,
            contact_phone:'',
            event_time:'',
            event_time_data:'',
            event_time_ora:'',
            privacy_type:'',
            password_list:'',
            description:'',
            location_county:'',
            location_city:'',
            location_street:'',
            location_text:'',
            type_of_titular_event:'',
            status:'',
            url_for_img:'',
            has_attached_image:''
        }
    }

}
